import { useEffect } from 'react';
import React from 'react';
import {
    PopularSuggestionType,
    PopularSuggestion,
} from 'types/searchSuggestion';
import SuggestionsChip from '../SuggestionsChip';


interface PopularSuggestionProps {
    popularSuggestionTypes: PopularSuggestionType[],
    fetchPopularSuggestions: () => void,
    handleClick: (suggestion: PopularSuggestion, position: number) => void
}

const View = ({
    popularSuggestionTypes,
    fetchPopularSuggestions,
    handleClick,
}: PopularSuggestionProps) => {
    useEffect(() => {
        fetchPopularSuggestions();
    }, [fetchPopularSuggestions]);

    if (!(popularSuggestionTypes?.length > 0)) {
        return null;
    }

    return <>
      { popularSuggestionTypes?.map((popularSuggestionType: PopularSuggestionType) => <SuggestionsChip
          key={popularSuggestionType?.id}
          popularSuggestionType={popularSuggestionType}
          handleClick={handleClick}
        />)
      }
    </>;
};

export default View;
